import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AddUpdateRoleHierarchy } from '../models/add-update-role.model';

@Injectable({
    providedIn: 'root'
})
export class RoleHierarchyService {
    constructor(private http: HttpClient) {}

    getAllRoleHierarchy() {
        return this.http.get<any>( `${environment.appOrgUrl}Role/GetAllRoleHierarchy`);
    }

    addRoleHierarchy(roleHierarchyData: AddUpdateRoleHierarchy){
        return this.http.post<any>( `${environment.appOrgUrl}Role/Roles`, roleHierarchyData);
    }

    getAssociatedUsers(roleHierarchyId: number){
        return this.http.get<any>( `${environment.appOrgUrl}User/AllRoleUsers/${roleHierarchyId}`);
    }

    transferRole(transferRoleData){
        return this.http.post<any>( `${environment.appOrgUrl}Role/TransferRole`, transferRoleData);
    }

    checkNodeChildAssociatedUsers(roleId){
        return this.http.get<any>( `${environment.appOrgUrl}Role/ChildRoleStatus/${roleId}`);
    }

    deleteRole(roleHierarchyId: number){
        return this.http.delete<any>( `${environment.appOrgUrl}Role/Roles/${roleHierarchyId}`);
    }
}